(function () {
  'use strict';

  const W = window.__warranty__;
  if (!W || !W.variantId) {
    console.warn('[Warranty] Product not found. Handle "warranty-addon" check karo.');
    return;
  }

  const STORAGE_KEY = 'citron_warranty_map';
  const TITLE_KEY = 'citron_warranty_title_map';

  function getMap() {
    try { return JSON.parse(sessionStorage.getItem(STORAGE_KEY) || '{}'); }
    catch { return {}; }
  }
  function saveMap(map) {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(map));
  }
  function setEntry(variantId, lineKey) {
    const map = getMap();
    map[String(variantId)] = lineKey;
    saveMap(map);
  }
  function deleteEntry(variantId) {
    const map = getMap();
    delete map[String(variantId)];
    saveMap(map);
  }
  function getLineKey(variantId) {
    return getMap()[String(variantId)] || null;
  }
  function hasWarranty(variantId) {
    return !!getLineKey(variantId);
  }

  function getTitleMap() {
    try { return JSON.parse(sessionStorage.getItem(TITLE_KEY) || '{}'); }
    catch { return {}; }
  }
  function saveTitleEntry(variantId, title) {
    const map = getTitleMap();
    map[String(variantId)] = title;
    sessionStorage.setItem(TITLE_KEY, JSON.stringify(map));
  }
  function getTitleEntry(variantId) {
    return getTitleMap()[String(variantId)] || '';
  }
  function deleteTitleEntry(variantId) {
    const map = getTitleMap();
    delete map[String(variantId)];
    sessionStorage.setItem(TITLE_KEY, JSON.stringify(map));
  }

  async function fetchCart() {
    const res = await fetch('/cart.js');
    return res.json();
  }

  async function cartAdd(quantity, parentVariantId, parentTitle) {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{
          id: W.variantId,
          quantity: quantity,
          properties: {
            '_warranty_for': String(parentVariantId),
            'For Product': parentTitle || '',
            '_hidden': '1'
          }
        }]
      })
    });
    if (!res.ok) throw new Error('Cart add failed');
    return res.json();
  }

  async function cartChange(lineKey, quantity) {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: lineKey, quantity: quantity })
    });
    if (!res.ok) throw new Error('Cart change failed');
    return res.json();
  }

  // IMPORTANT FIX
function delayedRefresh() {
  fetch('/cart.js')
    .then(r => r.json())
    .then(cart => {
      const amount = (cart.total_price / 100).toFixed(2);
      const formatted = `AED ${amount}`;

      document.querySelectorAll('.totals__subtotal-value').forEach(el => {
        el.textContent = formatted;
      });
    })
    .catch(err => console.error('[Warranty] Refresh failed:', err));
}

  function setLoading(checkbox, loading) {
    if (!checkbox) return;
    checkbox.disabled = loading;
    const label = checkbox.closest('label');
    if (label) label.style.opacity = loading ? '0.55' : '1';
  }

  async function addWarranty(parentVariantId, quantity, checkbox) {
    setLoading(checkbox, true);
    try {
      let parentTitle = getTitleEntry(parentVariantId);

      // Agar title nahi mila toh sirf ek baar cart fetch karo
      if (!parentTitle) {
        const upsell = document.querySelector('.warranty-upsell');
        if (upsell && upsell.dataset.productTitle) {
          parentTitle = upsell.dataset.productTitle;
          saveTitleEntry(parentVariantId, parentTitle);
        } else {
          // Cart page pe title directly DOM se lo - no fetch needed
          const cartRow = document.querySelector(`.cart-item[data-variant-id="${parentVariantId}"]`);
          if (cartRow) {
            const titleEl = cartRow.querySelector('.cart-item__name');
            if (titleEl) {
              parentTitle = titleEl.textContent.trim();
              saveTitleEntry(parentVariantId, parentTitle);
            }
          }
        }
      }

      // Sirf ek fetch - cart add
      const addResult = await cartAdd(quantity, parentVariantId, parentTitle);

      // addResult se directly key lo - dobara cart fetch mat karo
      const warrantyItem = addResult.items?.find(function (item) {
        return (
          item.variant_id === W.variantId &&
          item.properties &&
          item.properties['_warranty_for'] === String(parentVariantId)
        );
      });

      // Agar add result mein nahi mila toh ek baar fetch karo
      if (warrantyItem) {
        setEntry(parentVariantId, warrantyItem.key);
      } else {
        const cartAfter = await fetchCart();
        const found = cartAfter.items.find(function (item) {
          return (
            item.variant_id === W.variantId &&
            item.properties &&
            item.properties['_warranty_for'] === String(parentVariantId)
          );
        });
        if (found) setEntry(parentVariantId, found.key);
      }

      delayedRefresh();

    } catch (err) {
      console.error('[Warranty] Add failed:', err);
      if (checkbox) checkbox.checked = false;
    } finally {
      setLoading(checkbox, false);
    }
  }

  async function removeWarranty(parentVariantId, checkbox) {
    const lineKey = getLineKey(parentVariantId);
    if (!lineKey) return;
    setLoading(checkbox, true);
    try {
      await cartChange(lineKey, 0);
      deleteEntry(parentVariantId);
      deleteTitleEntry(parentVariantId);

      delayedRefresh();

    } catch (err) {
      console.error('[Warranty] Remove failed:', err);
      if (checkbox) checkbox.checked = true;
    } finally {
      setLoading(checkbox, false);
    }
  }

  async function syncQty(parentVariantId, newQty) {
    if (!hasWarranty(parentVariantId)) return;
    const lineKey = getLineKey(parentVariantId);
    if (!lineKey) return;
    try {
      if (newQty <= 0) {
        await cartChange(lineKey, 0);
        deleteEntry(parentVariantId);
        deleteTitleEntry(parentVariantId);
      } else {
        await cartChange(lineKey, newQty);
      }

      delayedRefresh();

    } catch (err) {
      console.error('[Warranty] Qty sync failed:', err);
    }
  }

  function restoreCheckboxStates() {
    document.querySelectorAll('.cart-item').forEach(function (row) {
      const variantId = String(row.dataset.variantId || '');
      if (!variantId) return;
      const cb = row.querySelector('.warranty-checkbox');
      if (cb) cb.checked = hasWarranty(variantId);
    });
  }

function initProductPage() {
  const upsell = document.querySelector('.warranty-upsell');
  if (!upsell) return;

  const checkbox = upsell.querySelector('.warranty-checkbox');
  if (!checkbox) return;

  const isSetProduct = upsell.dataset.isSet === 'true';
  let currentVariantId = String(upsell.dataset.productVariant || '');
  checkbox.checked = hasWarranty(currentVariantId);

  document.addEventListener('variant:change', function (e) {
    const newId = String(e.detail?.variant?.id || '');
    if (!newId || newId === currentVariantId) return;

    if (hasWarranty(currentVariantId)) {
      removeWarranty(currentVariantId, null);
    }

    currentVariantId = newId;
    upsell.dataset.productVariant = newId;
    checkbox.dataset.parentVariant = newId;
    checkbox.checked = hasWarranty(newId);
  });

  const atcBtn = document.querySelector('[name="add"], .product-form__submit, button[type="submit"]');
  if (!atcBtn) return;

  atcBtn.addEventListener('click', async function (e) {
    if (!checkbox.checked) return;
    if (window.__warrantyProcessing__) return;
    window.__warrantyProcessing__ = true;

    async function processWarranty(attempt) {
      try {
        const cart = await fetch('/cart.js').then(r => r.json());

        if (isSetProduct) {
          // ── SET PRODUCT: individual items pe warranty ──
          const alreadyWarrantied = new Set(
            cart.items
              .filter(i => i.properties && i.properties['_warranty_for'])
              .map(i => String(i.properties['_warranty_for']))
          );

          const itemsNeedingWarranty = cart.items.filter(i => {
            if (i.properties && i.properties['_hidden'] === '1') return false;
            if (i.variant_id === W.variantId) return false;
            if (i.title === 'Packaging') return false;
            if (String(i.variant_id) === String(currentVariantId)) return false; // set variant exclude
            return !alreadyWarrantied.has(String(i.variant_id));
          });

          console.log(`[Warranty] Set attempt ${attempt}:`, itemsNeedingWarranty.map(i => i.title));

          if (itemsNeedingWarranty.length === 0 && attempt < 3) {
            await new Promise(resolve => setTimeout(resolve, 1500));
            return processWarranty(attempt + 1);
          }

          for (const item of itemsNeedingWarranty) {
            const variantId = String(item.variant_id);
            const title = item.product_title || item.title || '';
            saveTitleEntry(variantId, title);

            const res = await fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                items: [{
                  id: W.variantId,
                  quantity: item.quantity,
                  properties: {
                    '_warranty_for': variantId,
                    'For Product': title,
                    '_hidden': '1'
                  }
                }]
              })
            });

            if (res.ok) {
              const cartUpdated = await fetch('/cart.js').then(r => r.json());
              const w = cartUpdated.items.find(i =>
                i.variant_id === W.variantId &&
                i.properties &&
                i.properties['_warranty_for'] === variantId
              );
              if (w) {
                setEntry(variantId, w.key);
                console.log('[Warranty] Added + saved key for:', title);
              }
            }
          }

          // Retry agar koi miss hua
          if (attempt < 3) {
            const cartFinal = await fetch('/cart.js').then(r => r.json());
            const finalWarrantied = new Set(
              cartFinal.items
                .filter(x => x.properties && x.properties['_warranty_for'])
                .map(x => String(x.properties['_warranty_for']))
            );
            const stillMissing = cartFinal.items.filter(i => {
              if (i.properties && i.properties['_hidden'] === '1') return false;
              if (i.variant_id === W.variantId) return false;
              if (i.title === 'Packaging') return false;
              if (String(i.variant_id) === String(currentVariantId)) return false;
              return !finalWarrantied.has(String(i.variant_id));
            });
            if (stillMissing.length > 0) {
              console.log('[Warranty] Still missing, retrying...', stillMissing.map(i => i.title));
              await new Promise(resolve => setTimeout(resolve, 1500));
              return processWarranty(attempt + 1);
            }
          }

        } else {
          // ── SINGLE PRODUCT: sirf ek warranty ──
          const alreadyWarrantied = cart.items.some(i =>
            i.properties &&
            i.properties['_warranty_for'] === String(currentVariantId)
          );

          if (alreadyWarrantied) {
            console.log('[Warranty] Already added for single product');
            return;
          }

          let parentTitle = getTitleEntry(currentVariantId);
          if (!parentTitle && upsell.dataset.productTitle) {
            parentTitle = upsell.dataset.productTitle;
            saveTitleEntry(currentVariantId, parentTitle);
          }

          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              items: [{
                id: W.variantId,
                quantity: 1,
                properties: {
                  '_warranty_for': String(currentVariantId),
                  'For Product': parentTitle,
                  '_hidden': '1'
                }
              }]
            })
          });

          if (res.ok) {
            const cartUpdated = await fetch('/cart.js').then(r => r.json());
            const w = cartUpdated.items.find(i =>
              i.variant_id === W.variantId &&
              i.properties &&
              i.properties['_warranty_for'] === String(currentVariantId)
            );
            if (w) {
              setEntry(currentVariantId, w.key);
              console.log('[Warranty] Added + saved key for single:', parentTitle);
            }
          }
        }

      } catch (err) {
        console.error('[Warranty] Processing failed:', err);
      }
    }

    await new Promise(resolve => setTimeout(resolve, 2500));
    await processWarranty(1);
    window.__warrantyProcessing__ = false;
  });
}

  function initCartPage() {
    const cartEl = document.querySelector('cart-items');
    if (!cartEl) return;

    syncStateFromCart().then(function () {
      attachQtyListeners();
    });

    let debounceTimer = null;
    const observer = new MutationObserver(function () {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(function () {
        syncStateFromCart().then(function () {
          attachQtyListeners();
          restoreCheckboxStates();
        });
      }, 300);
    });

    observer.observe(cartEl, { childList: true, subtree: true });
  }

async function syncStateFromCart() {
  try {
    const cart = await fetchCart();
    const map = {};
    cart.items.forEach(function (item) {
      if (
        item.variant_id === W.variantId &&
        item.properties &&
        item.properties['_warranty_for']
      ) {
        map[String(item.properties['_warranty_for'])] = item.key;

        if (item.properties['For Product']) {
          saveTitleEntry(
            item.properties['_warranty_for'],
            item.properties['For Product']
          );
        }
      }
    });
    // Poora map replace karo — stale entries hata do
    saveMap(map);

    // Cart drawer checkboxes bhi restore karo
    document.querySelectorAll('.warranty-checkbox').forEach(function (cb) {
      const parentVariantId = String(cb.dataset.parentVariant || '');
      if (parentVariantId) {
        cb.checked = hasWarranty(parentVariantId);
      }
    });

  } catch (e) {
    console.warn('[Warranty] State sync failed:', e);
  }
}

  function attachQtyListeners() {
    document.querySelectorAll('.cart-item').forEach(function (row) {
      const variantId = String(row.dataset.variantId || '');
      if (!variantId || row.dataset.wQtyListening) return;

      row.dataset.wQtyListening = '1';

      const qtyInput = row.querySelector('.quantity__input');
      if (!qtyInput) return;

      qtyInput.addEventListener('change', async function () {
        const newQty = parseInt(this.value, 10) || 0;
        await syncQty(variantId, newQty);
      });
    });
  }

  document.addEventListener('change', async function (e) {
    if (!e.target.classList.contains('warranty-checkbox')) return;

    const parentVariantId = String(e.target.dataset.parentVariant || '');
    if (!parentVariantId) return;

    if (e.target.checked) {
      const qtyInput = document.querySelector(
        `.cart-item[data-variant-id="${parentVariantId}"] .quantity__input`
      );
      const qty = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;
      await addWarranty(parentVariantId, qty, e.target);
    } else {
      await removeWarranty(parentVariantId, e.target);
    }
  });

  document.addEventListener('DOMContentLoaded', function () {
    initProductPage();
    initCartPage();
  });

  // ─── POPUP OPEN/CLOSE ─────────────────────────────────────
  document.addEventListener('click', function (e) {
    if (e.target.closest('.warranty-info-btn')) {
      e.preventDefault();
      e.stopPropagation();
      var popup = document.getElementById('warrantyPopup');
      if (popup) popup.style.cssText = 'display:flex!important;';
      return;
    }
    if (e.target.closest('.warranty-popup__close')) {
      e.preventDefault();
      e.stopPropagation();
      var popup = document.getElementById('warrantyPopup');
      if (popup) popup.style.cssText = 'display:none!important;';
      return;
    }
    if (e.target.id === 'warrantyPopup') {
      var popup = document.getElementById('warrantyPopup');
      if (popup) popup.style.cssText = 'display:none!important;';
      return;
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      var popup = document.getElementById('warrantyPopup');
      if (popup) popup.style.cssText = 'display:none!important;';
    }
  });

})();

